import {
    deleteDataPromise,
    getDataPromise,
    putDataPromise,
} from 'brock-fetch-utils';
import getUri from '../utils/getUri';

export function deprecatedGetIsFavorite(siteMapKey, parameterId) {
    const uri = parameterId
        ? `SiteMapApi/GetIsFavorite?siteMapKey=${siteMapKey}&parameterId=${parameterId}`
        : `SiteMapApi/GetIsFavorite?siteMapKey=${siteMapKey}`;

    return getDataPromise(getUri(uri));
}

export function deprecatedSaveFavorite(
    siteMapKey,
    favoriteName,
    source,
    parameterId,
    viewKey
) {
    return putDataPromise(getUri('SiteMapApi/SaveFavorite'), {
        siteMapKey,
        favoriteName,
        source,
        parameterId,
        viewKey,
    });
}

export function deprecatedDeleteFavorite(
    siteMapKey,
    favoriteName,
    source,
    parameterId
) {
    return deleteDataPromise(getUri('SiteMapApi/DeleteFavorite'), {
        siteMapKey,
        favoriteName,
        source,
        parameterId,
    });
}

export function deprecatedGetLandingPageWidgetUserFavorites() {
    return getDataPromise(getUri('SiteMapApi/GetUserFavorites'));
}
